import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Router } from "@angular/router"
import { IAuthService } from '../services/api/contracts/auth-service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {

  constructor(private router: Router, @Inject('IAuthService') private authService: IAuthService) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    if (await this.authService.isAuthenticated()) return true;

    await this.router.navigate(['/login']);

    return false;
  }

}
